/* SharpShine product card — task P1-07 (reference: prototype/ss-proto.js, SS.cardHTML, onChange and the card add).
   Loaded once, deferred, by snippets/ss-head.liquid, after ss-engine.js. Markup: snippets/ss-product-card.liquid.
   It listens at page level, so cards that arrive later (filters, "You may also like", theme-editor reloads)
   work without any set-up, and there is nothing to clean up.
   - A size button: the photo (after it is decoded), price, old price, saving and the card link follow it.
   - Add: SS.cartAdd below (shared with the product page since P1-08): Shopify's /cart/add with the cart drawer's sections
     while the photo flies to the basket; then the count jumps and Dawn's cart drawer opens. It sends Dawn's add-to-cart
     analytics event and the theme's "cart updated" message (pubsub), like Dawn's product form.
   - No motion engine, no fetch or no JavaScript: the form posts to Shopify's cart page as usual.
   No visible words live in this file: they come from the markup (locales ss.card.*) and from Shopify's answers. */
(function () {
  'use strict';
  var SS = (window.SS = window.SS || {});

  function cardOf(el) { return el && el.closest ? el.closest('[data-ss-card]') : null; }

  /* ---------- size buttons ---------- */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('.ss-card__sizes input[name="id"]')) return;
    var card = cardOf(input), d = input.dataset;
    if (!card) return;
    if (SS.pop) SS.pop(input);

    card.querySelector('[data-ss-price]').textContent = d.price || '';
    var compare = card.querySelector('[data-ss-compare]'), save = card.querySelector('[data-ss-save]');
    compare.textContent = d.compare || '';
    compare.parentNode.hidden = !d.compare;
    save.textContent = d.save || '';
    save.hidden = !d.save;
    if (SS.tick) SS.tick(card.querySelector('.ss-card__price'));

    var media = card.querySelector('.ss-card__media'), img = card.querySelector('.ss-card__img');
    if (img && d.src && media.dataset.img !== d.img) {
      media.dataset.img = d.img;
      if (SS.swapImg) SS.swapImg(img, d.src, d.srcset);
      else { img.srcset = d.srcset; img.src = d.src; }
    }
    var link = card.querySelector('[data-ss-card-link]');
    if (link && d.url) link.href = d.url;
    card.querySelector('[data-ss-card-error]').textContent = '';
  });

  /* ---------- Add ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-ss-card-form]')) return;
    if (!SS.addFlow || !window.fetch || !window.routes) return; // Shopify's own cart page takes over
    e.preventDefault();
    var card = cardOf(form), btn = form.querySelector('[data-ss-card-add]');
    if (!card || !btn) return;
    SS.cartAdd({
      btn: btn,
      media: card.querySelector('.ss-card__media'),
      items: [{ id: Number(new FormData(form).get('id')), quantity: 1 }],
      errorEl: card.querySelector('[data-ss-card-error]'),
      eventTarget: form,
      source: 'ss-card'
    });
  });

  /* ---------- Shared add to cart (cards, product page, sticky bar, bundle — P1-08) ----------
     o.items: [{ id, quantity }] in one Shopify request (/cart/add with the cart drawer's sections: a form like Dawn's product
     form for one item, JSON for several) while the photo o.media flies to the basket (SS.addFlow on o.btn). Then: Shopify's "lines added" event, the
     theme's "cart updated" message, the count jumps and Dawn's cart drawer opens. A refused add writes Shopify's message
     into o.errorEl and sends Shopify's cart error event. Resolves true when the items are in the cart. */
  SS.cartAdd = function (o) {
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var answer = null, target = o.eventTarget || o.btn, one = o.items.length === 1;
    var sections = cart ? cart.getSectionsToRender().map(function (s) { return s.id; }) : null;
    var headers = { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body;
    if (one) { // one item: the same form request as Dawn's product form
      body = new FormData();
      body.append('id', o.items[0].id);
      body.append('quantity', o.items[0].quantity);
      if (sections) { body.append('sections', sections); body.append('sections_url', window.location.pathname); }
    } else { // several items (bundle): one JSON request
      headers['Content-Type'] = 'application/json';
      headers.Accept = 'application/json';
      body = JSON.stringify(sections
        ? { items: o.items, sections: sections, sections_url: window.location.pathname }
        : { items: o.items });
    }
    if (cart) cart.setActiveElement(o.btn);
    if (o.errorEl) o.errorEl.textContent = '';

    return SS.addFlow(o.btn, o.media, function () {
      return fetch(window.routes.cart_add_url, { method: 'POST', headers: headers, body: body })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          /* a refusal: { status, message, description } for a form request, { errors } for a JSON one */
          if (res.status || res.errors) {
            var e = res.errors, why = res.description || res.message ||
              (typeof e === 'string' ? e : e ? [].concat.apply([], Object.keys(e).map(function (k) { return e[k]; })).join(' ') : '');
            var err = new Error(why); err.shopify = res; err.why = why; throw err;
          }
          answer = res;
        });
    }).then(function (done) {
      if (!done || !answer) return false;
      linesAdded(target, o.items);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: o.source || 'ss', productVariantId: o.items[0].id, cartData: answer });
      }
      if (!cart) { window.location = window.routes.cart_url; return true; }
      /* the count jumps first (the photo has landed), then the drawer opens */
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && answer.sections && answer.sections['cart-icon-bubble']) {
        bubble.innerHTML = cart.getSectionInnerHTML(answer.sections['cart-icon-bubble'], '.shopify-section');
        if (SS.bump) SS.bump(bubble.querySelector('.ss-count'), 'is-bump');
      }
      setTimeout(function () {
        cart.classList.remove('is-empty');
        cart.renderContents(answer);
      }, 450);
      return true;
    }, function (err) {
      var res = err && err.shopify, el = o.errorEl;
      var msg = (err && err.why) || (el && el.dataset.fallback) || '';
      if (el) el.textContent = msg;
      var CartErrorEvent = window.StandardEvents && window.StandardEvents.CartErrorEvent;
      if (CartErrorEvent) target.dispatchEvent(new CartErrorEvent({ error: msg, code: res ? 'INVALID' : 'SERVICE_UNAVAILABLE' }));
      return false;
    });
  };

  /* Shopify analytics: the same "lines added" event Dawn's product form sends (assets/product-form.js), sent once the
     add has worked, with the real quantities. A refused add sends Shopify's cart error event instead: a rejected "lines"
     promise would surface as a page error, because Shopify's own script does not catch it. */
  function linesAdded(target, items) {
    var CartLinesUpdateEvent = window.StandardEvents && window.StandardEvents.CartLinesUpdateEvent;
    if (!CartLinesUpdateEvent) return;
    var deferred = CartLinesUpdateEvent.createPromise();
    target.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: items.map(function (it) { return { merchandiseId: String(it.id), quantity: it.quantity }; }),
      promise: deferred.promise
    }));
    var cartData = typeof CartItems !== 'undefined' && CartItems.fetchCartData
      ? CartItems.fetchCartData()
      : fetch(window.routes.cart_url + '.json').then(function (r) { return r.json(); });
    cartData.then(function (c) {
      if (!c || !c.currency) return deferred.reject(new Error('Missing currency in cart response'));
      deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(c) });
    }).catch(function (err) { deferred.reject(err); });
  }
})();

/* ---------- hover video (computers with a mouse; not with reduced motion) ----------
   Hovering a card whose photo box carries data-yt (the product's YouTube video) plays it muted, without controls, over the photo.
   The frame is made only on hover (nothing loads before), shown once YouTube says it is playing, removed on leave. */
(function () {
  'use strict';
  var mouse = window.matchMedia('(hover: hover) and (pointer: fine)');
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');
  var OPEN_MS = 250, CLOSE_MS = 300;
  function cardOf(el) { return el && el.closest ? el.closest('[data-ss-card]') : null; }

  function open(media) {
    var id = media.dataset.yt, f = document.createElement('iframe');
    f.className = 'ss-card__video';
    f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&mute=1&controls=0&playsinline=1&rel=0&iv_load_policy=3&disablekb=1&enablejsapi=1&origin=' + encodeURIComponent(location.origin);
    f.allow = 'autoplay; encrypted-media';
    f.tabIndex = -1;
    f.setAttribute('aria-hidden', 'true');
    f.addEventListener('load', function () {
      try { f.contentWindow.postMessage(JSON.stringify({ event: 'listening', id: id }), '*'); } catch (e) {}
      media._ssShow = setTimeout(function () { media.classList.add('is-video'); }, 1500); // if YouTube never answers
    });
    media.appendChild(f);
  }

  function close(media) {
    clearTimeout(media._ssOpen); clearTimeout(media._ssShow);
    media._ssOpen = null;
    media.classList.remove('is-video');
    var f = media.querySelector('.ss-card__video');
    if (f) setTimeout(function () { if (!media.classList.contains('is-video')) f.remove(); }, CLOSE_MS);
  }

  document.addEventListener('mouseover', function (e) {
    if (!mouse.matches || still.matches) return;
    var card = cardOf(e.target), media = card && card.querySelector('.ss-card__media[data-yt]'); // the card's stretched link covers the photo
    if (!media || media._ssOpen) return;
    if (media.querySelector('.ss-card__video')) { media.classList.add('is-video'); return; } // back within the fade-out
    media._ssOpen = setTimeout(function () { open(media); }, OPEN_MS); // a short pause, so passing the mouse over cards loads nothing
  });
  document.addEventListener('mouseout', function (e) {
    var card = cardOf(e.target), media = card && card.querySelector('.ss-card__media[data-yt]');
    if (media && !card.contains(e.relatedTarget)) close(media);
  });
  // YouTube's player messages: show the frame once it plays (state 1); start again when it ends (state 0)
  window.addEventListener('message', function (e) {
    if (!/youtube(-nocookie)?\.com$/.test(e.origin)) return;
    var d; try { d = JSON.parse(e.data); } catch (err) { return; }
    var state = d && d.event === 'infoDelivery' && d.info ? d.info.playerState : null;
    if (state !== 1 && state !== 0) return;
    document.querySelectorAll('.ss-card__video').forEach(function (f) {
      if (f.contentWindow !== e.source) return;
      var m = f.parentNode;
      if (state === 0) { // ended: start again (YouTube's own loop adds next/previous buttons)
        ['seekTo', 'playVideo'].forEach(function (fn) {
          f.contentWindow.postMessage(JSON.stringify({ event: 'command', func: fn, args: fn === 'seekTo' ? [0, true] : [] }), '*');
        });
        return;
      }
      clearTimeout(m._ssShow);
      m._ssShow = setTimeout(function () { if (m.contains(f)) m.classList.add('is-video'); }, 600); // let YouTube's start overlay fade first
    });
  });
})();
